<div class="custom-form-wrapper">
	<div class="custom-form" v-if="state === 'ready'">
		<h2 class="title custom-form__title">{{ form.title }}</h2>
		<div class="content" v-html="textHtml" />

		<div class="custom-form__fields columns is-multiline">
			<component :is="getComponentName(field)" :form="form" :field="field" :values="values" :validations="validations" v-model="values[field.name]" @update:modelValue="onFieldChanged(field)" ref="fieldComponents" v-for="field of form.fields" />

			<div class="column is-full py-0" v-if="privacyPolicyUrl">Informationen zum Umgang mit den übermittelten Daten finden Sie in unserer <a :href="privacyPolicyUrl" target="_blank">Datenschutzerklärung</a>.</div>

			<div class="column is-full columns is-mobile is-gapless custom-form__controls">
				<div class="column">
					<b-button type="is-primary" rounded @click="submit">{{ submitButtonText }}</b-button>
				</div>
				<div class="column is-narrow">
					<button type="button" class="button is-light is-icon is-rounded custom-form__reset-button" @click="reset" aria-label="Formular Zurücksetzen">
						<span class="is-hidden-mobile">Zurücksetzen</span>
						<svg class="is-hidden-tablet" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 69.4"><path d="M90.1 0H31.4c-1.4 0-2.8.6-3.7 1.7L1.3 31.4a4.9 4.9 0 000 6.6l26.3 29.7a4.8 4.8 0 003.7 1.7H90c2.8 0 5-2.2 5-5V5c.1-2.8-2.1-5-4.9-5zm-5 59.5H33.6L11.7 34.7 33.6 9.9h51.5v49.6z" /><path d="M41.2 49.3a4.85 4.85 0 007 0l7.6-7.6 7.6 7.6a4.85 4.85 0 007 0c1.9-1.9 1.9-5.1 0-7l-7.6-7.6 7.6-7.6c1.9-1.9 1.9-5.1 0-7s-5.1-1.9-7 0l-7.6 7.6-7.6-7.6c-1.9-1.9-5.1-1.9-7 0s-1.9 5.1 0 7l7.6 7.6-7.6 7.6c-2 1.9-2 5.1 0 7z" /></svg>
					</button>
				</div>
			</div>
		</div>
	</div>

	<b-notification class="custom-form__result" type="is-success" :closable="false" key="actionSuccess" v-if="state === 'actionSuccess'">
		<div class="mb-2 content" v-html="successMessageHtml" />
		<b-button class="is-align-visual-left" type="is-light" rounded @click="close">Schliessen</b-button>
	</b-notification>

	<b-notification class="custom-form__result" type="is-danger" :closable="false" key="actionError" v-if="state === 'actionError'">
		<div class="mb-2 content" v-html="errorMessageHtml" />
		<b-button class="is-align-visual-left" type="is-light" rounded @click="close">Schliessen</b-button>
	</b-notification>

	<b-notification class="custom-form__result" type="is-light" :closable="false" key="error" v-if="state === 'error'">
		<div class="mb-2 content">
			<h2 class="title is-4">Leider funktioniert das Formular nicht</h2>
			<p>Wir wurden bereits über das Problem informiert und werden es möglichst schnell beheben.</p>
			<p>Wenn Sie uns etwas mitteilen möchten, erreichen Sie uns über <a href="mailto:mail@trans-fair.ch">mail@trans-fair.ch</a> oder <a href="tel:+41333340444">033 334 04 44</a>.</p>
		</div>
		<b-button class="is-align-visual-left" type="is-dark" rounded @click="close">Schliessen</b-button>
	</b-notification>

	<b-loading :is-full-page="true" :active="state === 'loading'"></b-loading>
</div>
